import React, { useEffect } from "react";
import { connect } from "react-redux";

import { MultiSelect } from "../MultiSelect";
import { useProcurementMethods } from "newui/store";
import { Spinner } from "@chakra-ui/react";

export const ProcurementMethodSelector = ({
	name,
	setFieldValue,
	values,
	defaultValue,
	testId,
	guideLine,
	...props
}) => {
	const { values: methods, isLoading } = useProcurementMethods();

	//use this var to create proper label/value obj
	let valueObj = [];

	//pick out the initial values from the options array based on method id's from form
	if (Array.isArray(values[name] && !isLoading)) {
		valueObj = values[name].map((id) => {
			return methods?.find((option) => {
				return option.value === id;
			});
		});
	}

	return (
		<MultiSelect
			aria-labelledby="multi-select-label"
			aria-describedby="multi-select-description"
			closeMenuOnSelect={false}
			label="Procurement Model"
			options={!isLoading && methods}
			testId={testId}
			name={name}
			value={valueObj}
			guideLine={guideLine}
			isGuideLineLink
			className={props.className}
			isLoading={isLoading}
		/>
	);
};
